module.exports = __webpack_public_path__ + "static/sport/slide3.08edc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/slide3.png
// module id = IHDB
// module chunks = 0